module.exports = __webpack_public_path__ + "static/logo-big-imperia-aca3a78fdc19192c90a1581996c88340.png";